import React from "react";
import ReportPublicHeader from "@pages/Report/components/ReportPublicHeader";
import { useNavigate } from "react-router-dom";

const ErrorReport: React.FC = () => {
  const navigation = useNavigate();

  const handleReload = () => {
    navigation("/login");
  };

  return (
    <>
      <ReportPublicHeader />
      <div className="flex min-h-[75vh] flex-1 flex-col justify-center px-6 pt-8 lg:px-8 items-center">
        <h2 className="text-3xl font-semibold mb-6">
          Report no longer available.
        </h2>
        <p className="text-gray-400 mb-6 text-lg">
          Please contact the report owner
        </p>
        <img
          src="/report-error.svg"
          className="my-5"
          alt="Error illustration"
        />

        <button
          onClick={handleReload}
          className="bg-[#0357C9] text-white px-4 py-2 rounded-md mt-4"
        >
          Home
        </button>
      </div>
    </>
  );
};

export default ErrorReport;
